import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import CommonImagePreview from '../components/CommonImagePreview';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

const ATTACH_FILE_CONTENT_URL = `api/master/attach_files/files`;

class DataTableTypeAStudent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageUrls: {} 
        };
    }

    componentDidMount() {
        this.loadImages();
    }
    
    componentDidUpdate(prevProps) {
        const prevRows = prevProps.DataTable?.rows || [];
        const currentRows = this.props.DataTable?.rows || [];
    
        const hasChanged = prevRows.length !== currentRows.length ||
            prevRows.some((prevRow, i) => {
                const currRow = currentRows[i];
                return prevRow.id !== currRow.id ||
                       prevRow.image !== currRow.image;
            });
    
        if (hasChanged) {
            this.loadImages();
        }
    }

    loadImages = async () => {
        const { DataTable } = this.props;
        const imageUrls = await Actions.loadImageBlobUrls({
            rows: DataTable.rows,
            fileField: "image",
            idField: "id",
            baseUrl: ATTACH_FILE_CONTENT_URL
        });
        this.setState({ imageUrls });
    };

    render() {

        let props = this.props;

        let { onSetEdit, onPreviewFile, onNavigate, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Masterbase} = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
            if (row?.type_a_academy_rows === 0) { deleteChecked++; }
        });

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead >
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-100p"></th>
                                        <th className="th-width-auto-max"></th>
                                        {/** <th className="th-width-225p"></th> */}
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            {deleteChecked > 0 && (
                                                <Form.Check 
                                                    type="checkbox"
                                                    checked={Deletes.checkAll}
                                                    onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {

                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                        
                                        rowId++;

                                        let del = true;
                                        if (row.type_a_academy_rows > 0) { del = false; }

                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {!util.isEmpty(row.image) && (
                                                            <CommonImagePreview
                                                                src={this.state.imageUrls?.[row.id] || null}
                                                                width={80}
                                                                height={80}
                                                                alt="รูปภาพ"
                                                            />
                                                        )}
                                                    </td>                                                    
                                                    <td className="text-truncate" title={row.name + ' ' + row.lastname}>
                                                        {row.name} {row.lastname} 

                                                        {(row.location || row.phone_number) && (
                                                            <p className="title-xs mt-1 mb-0 d-flex flex-wrap align-items-center">
                                                                {row.location && (
                                                                <>
                                                                    <i className="fa-classic fa-light fa-location-dot fa-fw me-2"></i>
                                                                    ที่อยู่ {row.location}
                                                                </>
                                                                )}
                                                                {row.location && row.phone_number && (
                                                                <span className="me-2"></span> 
                                                                )}
                                                                {row.phone_number && (
                                                                <>
                                                                    <i className="fa-classic fa-light fa-phone fa-fw me-2"></i>
                                                                    เบอร์โทรศัพท์ {util.renderText(row.phone_number)}
                                                                </>
                                                                )}
                                                            </p>
                                                        )}

                                                        {(row.type_a_academy_rows > 0) && 
                                                            <p className="title-xs mb-0 mt-1">
                                                                <i className="fa-classic fa-light fa-place-of-worship fa-fw me-2"></i>
                                                                สถานศึกษา 
                                                                <Badge className="badge-sm ms-2" pill bg="dark">{util.formatNumber(row.type_a_academy_rows, true)}</Badge>
                                                            </p>
                                                        }                                                         
                                                                                                    
                                                    </td>
                                                    {/** 
                                                    <td>
                                                        <CommonButtonBadge 
                                                            info={{text: 'สถานศึกษา', count: row.type_a_academy_rows}}
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onNavigate(e, { element: [{ id: 'type_a_academy_id', value: row.id, label: row.name}] })} 
                                                        />
                                                    </td>
                                                    */}
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="edit" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.id})} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.id}
                                                                checked={Deletes.deletes.includes(row.id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableTypeAStudent;
